<template>
    <div class="fig box_fig">
        <div v-if="empty" :style="{ width: fig_data.width, height: fig_data.height }">
            <el-empty description="No data"></el-empty>
        </div>
        <div v-else :id="random_id" :style="{ width: fig_data.width, height: fig_data.height }"></div>
        <el-dialog
            title=""
            :visible.sync="fullFlag"
            width="90%"
            top='5vh'
            ref='dialog'
            >
            <div :id="full_random_id" :style="{ width: screenWidth*0.85+'px', height: screenHeight*0.75+'px' }"></div>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from 'echarts/core';
import {
    DatasetComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    DataZoomComponent,
    TransformComponent,
    ToolboxComponent,
    MarkLineComponent
} from 'echarts/components';
import { BoxplotChart, ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

import {uuid,full_icons} from "@/bus.js";

echarts.use([
    DatasetComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    DataZoomComponent,
    TransformComponent,
    BoxplotChart,
    ScatterChart,
    CanvasRenderer,
    UniversalTransition,
    ToolboxComponent,
    MarkLineComponent
]);

import '@/assets/js/ecSimpleTransform.min.js'

export default {
    props: ["fig_data", "loading","empty"],
    name: 'browse',
    data: function () {
        return {
            random_id:'x',
            // loading: true,
            // fig_data:{
            //     width: "400px",
            //     height: "400px",
            //     plot_data:{
            //         data:[],
            //         val_col:'',
            //         cate_col:'',
            //         detail_cols:[],
            //         title:'',
            //     }
            // },
            myChart: null,
            fullFlag:false,
            full_random_id:'y',
            fullChart:null,
            screenHeight:document.documentElement.clientHeight,
            screenWidth:document.documentElement.clientWidth,
            full_icon:full_icons['expand'],
            mini_icon:full_icons['mini']
        }
    },
    created:function(){
        this.random_id=uuid();
        this.full_random_id=uuid()
        // setTimeout(this.full_random_id=uuid(), 100);
    },
    mounted: function () {
        this.$refs.dialog.rendered=true
        this.myChart = echarts.init(document.getElementById(this.random_id));
        this.myChart.showLoading();
        var _this = this
        window.onresize = function () {
            _this.screenWidth = document.documentElement.clientWidth
            _this.screenHeight = document.documentElement.clientHeight
            if(_this.myChart!==null){
              _this.myChart.resize();
            }
            if(_this.fullChart!==null){
              _this.fullChart.resize();
            }
        }
    },

    watch: {
        loading: function () {
            this.myChart.dispose();
            this.myChart = echarts.init(document.getElementById(this.random_id));
            if (this.loading) {
                this.myChart.showLoading();
            }
            else {
                this.plot(this.fig_data.plot_data,this.myChart,this.full_icon)
            }
        }
    },

    methods: {
        plot(plot_data,chart,full_icon) {
            // myChart.dispose();
            // console.log(plot_data);
            // _rawData[0][0] = '-log10(P-value)'
            // for (var i = 1; i < _rawData.length; i++) {
            //     _rawData[i][0] = -Math.log10(_rawData[i][0]);
            // }
            var valCol = plot_data.val_col;
            var cateCol = plot_data.cate_col;
            // console.log(_rawData)
            // 基于准备好的dom，初始化echarts实例
            echarts.registerTransform(window.ecSimpleTransform.aggregate);
            var option = {
                textStyle:{fontFamily :"Arial",color:'#000000'},
                dataset: [
                    {
                        id: 'raw',
                        source: plot_data.data
                    },
                    {
                        id: 'income_aggregate',
                        fromDatasetId: 'raw',
                        transform: [
                            {
                                type: 'ecSimpleTransform:aggregate',
                                config: {
                                    resultDimensions: [
                                        { name: 'min', from: valCol, method: 'min' },
                                        { name: 'Q1', from: valCol, method: 'Q1' },
                                        { name: 'median', from: valCol, method: 'median' },
                                        { name: 'Q3', from: valCol, method: 'Q3' },
                                        { name: 'max', from: valCol, method: 'max' },
                                        { name: cateCol, from: cateCol }
                                    ],
                                    groupBy: cateCol
                                }
                            },
                            {
                                type: 'sort',
                                config: {
                                    dimension: 'median',
                                    order: 'asc'
                                }
                            }
                        ]
                    }
                ],
                title: {
                    text: plot_data.title,
                    left: 'center',
                    textStyle:{fontFamily :"Arial",fontSize : 16},
                },
                tooltip: {
                    trigger: 'axis',
                    confine: true
                },

                xAxis: {
                    name: valCol,
                    nameLocation: 'middle',
                    nameGap: 30,
                    scale: true,
                    min:0
                },
                yAxis: {
                    type: 'category'
                },
                grid: {
                    left: '35%',
                    right: '5%',
                    bottom: '15%'
                },
                legend: {
                    top: 25,
                    left: 'center'
                    //   selected: { detail: false }
                },
                toolbox: {
                    show: true,
                    showTitle: false,
                    feature: {
                        restore: {},
                        saveAsImage: {},
                        myFull: {
                            show: true,
                            title: 'Full screen',
                            icon: full_icon,
                            onclick: (e) => {
                                this.showFullScreen(e.getOption())
                            },
                        }
                    }
                },
                // dataZoom: [
                //     {
                //         type: 'inside'
                //     },
                //     {
                //         type: 'slider',
                //         height: 20
                //     }
                // ],
                series: [
                    {
                        name: 'boxplot',
                        type: 'boxplot',
                        datasetId: 'income_aggregate',
                        itemStyle: {
                            color: '#b8c5f2'
                        },
                        encode: {
                            x: ['min', 'Q1', 'median', 'Q3', 'max'],
                            y: cateCol,
                            itemName: [cateCol],
                            tooltip: ['min', 'Q1', 'median', 'Q3', 'max']
                        }
                    },
                    {
                        name: 'detail',
                        type: 'scatter',
                        datasetId: 'raw',
                        symbolSize: 6,
                        tooltip: {
                            trigger: 'item'
                        },
                        itemStyle: {
                            color: '#d00000'
                        },
                        encode: {
                            x: valCol,
                            y: cateCol,
                            tooltip: plot_data.detail_cols,
                        },
                        // markLine:{
                        //     symbol:"none",
                        //     lineStyle: {
                        //         color: '#333'
                        //     },
                        //     label:{
                        //         position:'start',
                        //         formatter:""
                        //     },
                        //     data:[
                        //         {xAxis:Math.log10(0.05/plot_data.data.length-1)},
                        //     ]
                        // }
                    }
                ],
            };
            setTimeout(chart.setOption(option, true), 500);
            // myChart.setOption(option);
        },
        showFullScreen() {
            if (this.fullFlag) {
                this.fullFlag = false
            } else {
                this.fullFlag = true
                if(this.fullChart!=null){
                    this.fullChart.dispose();
                }
                this.fullChart = echarts.init(document.getElementById(this.full_random_id));
                this.plot(this.fig_data.plot_data,this.fullChart,this.mini_icon)
            }
        }
    }
}
</script>



<style>
</style>


// WEBPACK FOOTER //
// src/components/plot/box.vue